export default __webpack_public_path__ + "static/media/trr-drink-coffeecocktail-elevatedcoffeetonic.2894bf11.png";